<template>
  <small-modal-container :is-visible="userStore.loginPopup" :close-on-overlay="false" @close="closeSignin">
    <div class="login-content">
      <button class="close-x" @click="closeSignin" aria-label="닫기">
        &times;
      </button>

      <!-- 소셜 로그인 선택 -->
      <signin-content v-if="currentView === 'signin'" @switchToSignup="currentView = 'signup'"
        @switchToEmailLogin="currentView = 'emailLogin'" />

      <!-- 이메일 로그인 폼 -->
      <email-login-form v-else-if="currentView === 'emailLogin'" @back="currentView = 'signin'"
        @switchToSignup="currentView = 'signup'" @success="handleLoginSuccess" />

      <!-- 회원가입 폼 -->
      <signup-form v-else-if="currentView === 'signup'" @cancel="closeSignin" @switchToLogin="currentView = 'signin'"
        @success="handleSignupSuccess" />
    </div>
  </small-modal-container>
</template>

<script>
import { useUserStore } from "@/store/user";
import SigninContent from "@/components/SigninContent.vue";
import EmailLoginForm from "@/components/modal/EmailLoginForm.vue";
import SignupForm from "@/components/modal/form/SignupForm.vue";
import SmallModalContainer from "@/components/modal/SmallModalContainer.vue";

export default {
  name: "LoginPopup",
  components: {
    SigninContent,
    EmailLoginForm,
    SignupForm,
    SmallModalContainer,
  },
  data() {
    return {
      currentView: "signin", // 'signin', 'emailLogin', 'signup'
    };
  },
  computed: {
    userStore() {
      return useUserStore();
    },
  },
  watch: {
    // 라우트 변경 시 로그인 팝업 닫기
    $route() {
      if (this.userStore.loginPopup) {
        this.userStore.closeLoginPopup();
      }
    },
    // 로그인 상태 변경 시 팝업 닫기
    "userStore.isLogin"(newVal) {
      if (newVal && this.userStore.loginPopup) {
        this.userStore.closeLoginPopup();
      }
    },
  },
  methods: {
    closeSignin() {
      this.userStore.closeLoginPopup();
      this.currentView = "signin"; // 폼 상태 초기화
    },

    handleLoginSuccess(userData) {
      // 이메일 로그인 성공 시 처리
      // console.log("로그인 성공:", userData);

      // UserStore의 setUserData 메서드를 사용하여 사용자 정보 저장
      this.userStore.setUserData(userData);

      this.$alert(`로그인되었습니다!\n환영합니다, ${userData.nickname}님!`);
      this.closeSignin();
    },

    handleSignupSuccess(userData) {
      // 회원가입 성공 시 처리
      // console.log("회원가입 성공:", userData);

      // UserStore의 setUserData 메서드를 사용하여 사용자 정보 저장
      this.userStore.setUserData(userData);

      this.$alert(
        `회원가입이 완료되었습니다!\n환영합니다, ${userData.nickname}님!`
      );
      this.closeSignin();
    },
  },
};
</script>

<style scoped>
.login-content {
  padding: 50px 24px 40px 24px;
  text-align: center;
  position: relative;
}

.close-x {
  position: absolute;
  top: 18px;
  right: 24px;
  background: none;
  border: none;
  font-size: 2rem;
  color: #888;
  cursor: pointer;
  z-index: 21;
  padding: 0;
  line-height: 1;
  transition: color 0.2s;
}

.close-x:hover {
  color: #222;
}

/* 반응형 디자인 */
@media screen and (max-width: 480px) {
  .login-content {
    padding: 40px 20px 30px 20px;
  }

  .close-x {
    top: 15px;
    right: 20px;
    font-size: 1.8rem;
  }
}
</style>
